import { useState } from 'react';

import { EmptyStateNotFoundImage } from '@assets/images';
import TableTemplate2 from '@components/tableTemplate2';
import useGetAuditTrail from '@domain/auditTrail/useGetAuditTrail';
import { useFilter } from '@pages/AuditTrailSellOut/state/filters';
import { useMainState } from '@pages/AuditTrailSellOut/state/state';
import { find, reject } from 'lodash';
import { tableList } from './const';
import './styles.css';

const Table = () => {
    const filters = useFilter();
    const [sortType, setSortType] = useState();
    const { data, isLoading } = useGetAuditTrail({ ...filters, sort: sortType });
    const { onChangeMainState, selectedExportAuditTrail } = useMainState();

    const handlePageClick = ({ selected }) => filters.setFilter({ page: selected + 1 });
    const onResetSelectedRow = () => onChangeMainState({ selectedExportAuditTrail: [] });
    const onCheckAllRow = () => onChangeMainState({ selectedExportAuditTrail: data?.data });
    const onChangeLimit = (e) => filters.setFilter({ page: 1, limit: e.target.value });

    const onChangeCheckbox = ({ values }) => {
        let arr = [...selectedExportAuditTrail];
        const isExistSelectedAuditTrail = find(selectedExportAuditTrail, { id: values?.id });

        if (isExistSelectedAuditTrail) arr = reject(arr, { id: values?.id });
        else arr.push(values);

        onChangeMainState({
            selectedExportAuditTrail: arr,
        });
    };

    const onChangeBulkCheckbox = (value) => {
        onChangeMainState({ selectedExportAuditTrail: value });
    };

    return (
        <TableTemplate2
            isLoading={isLoading}
            data={data?.data}
            tableList={tableList}
            totalData={data?.totalData}
            totalPage={data?.totalPage}
            handlePageClick={handlePageClick}
            isPagination
            isSearch={filters?.searchQuery}
            noResultSearchImage={<EmptyStateNotFoundImage />}
            page={filters?.page}
            dataCount={data?.data?.length}
            onClickByRow={onChangeCheckbox}
            onResetSelectedRow={onResetSelectedRow}
            selectedRow={selectedExportAuditTrail}
            onCheckAllRow={onCheckAllRow}
            limit={filters?.limit}
            onChangeBulkCheckbox={onChangeBulkCheckbox}
            onChangeLimit={onChangeLimit}
            sortType={sortType}
            description={<>Saat ini, data audit trail sellout belum tersedia</>}
            onSort={(value) => {
                if (sortType?.name === value) {
                    setSortType({ type: sortType.type === 'desc' ? 'asc' : 'desc', name: value });
                } else {
                    setSortType({ type: 'desc', name: value });
                }
            }}
        />
    );
};

export default Table;
